import Vue from "vue";
import Vuex from "vuex";
import cartStore from './modules/cartStore'
import locationStore from './modules/locationStore'
import userStore from './modules/userStore'
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        cartStore,
        locationStore,
        userStore
    },
    plugins: [createPersistedState({
        key: 'wtf_storage',
        paths: ['cartStore','locationStore','userStore']
    })],
})